
export function descriptionPromoBlocksDescriptionInit() {
    const descriptionPromoBlocks = document.querySelectorAll('.js-promo-block-description');
    descriptionPromoBlocks.forEach(promoBlock => {
        const code = promoBlock.getAttribute('data-code');
        const source = document.querySelector('.js-promo-block-source[data-code="' + code + '"]');

        if (source) {
            promoBlock.innerHTML = source.innerHTML;
        }
    });
}

export async function glidePromoBlockDescriptionInit() {
    const elements = document.querySelectorAll('.glide--promo-block-description')
    if (elements.length) {
        let {default: Glide, Anchors, Breakpoints, Controls, Swipe} = await import("@glidejs/glide/dist/glide.modular.esm");
        elements.forEach(element => {
            new Glide(element, {
                // type: 'carousel',
                gap: '20px',
                perView: 3,
                peek: 100,
                bound: true,
                breakpoints: {
                    768: {
                        perView: 1,
                        peek: 0
                    },
                    1199: {
                        perView: 2,
                        peek: 0
                    }
                }
            }).mount({Anchors, Breakpoints, Controls, Swipe});
        });
    }
}
